<template>
  <el-dialog
    :title="model.id ? '编辑保养规则' : '新增保养规则'"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="规则名称" prop="name">
        <el-input v-model="model.name"></el-input>
      </el-form-item>
      <el-form-item label="设备分类" prop="item_category_id">
        <ItemCategorySelect
          :val="model.item_category_id"
          :category="2"
          @change="model.item_category_id = $event"
        ></ItemCategorySelect>
      </el-form-item>
      <el-form-item label="设备号" prop="equipment_number">
        <el-input
          v-model="model.equipment_number"
          placeholder="多个设备号请用顿号（、）隔开"
        ></el-input>
      </el-form-item>
      <el-form-item label="应用" prop="application">
        <DeviceApplicationSelect
          v-model="model.application"
        ></DeviceApplicationSelect>
      </el-form-item>
      <el-form-item label="工艺" prop="craft">
        <DeviceCraftSelect
          v-model="model.craft"
          :application="model.application"
        ></DeviceCraftSelect>
      </el-form-item>
      <el-form-item label="保养周期" prop="period">
        <el-input v-model.number="model.period" style="width: 50%"
          ><template slot="prepend">每</template
          ><template slot="append">月一次</template></el-input
        >
      </el-form-item>
      <el-form-item label="保养套餐">
        <div
          v-for="(item, index) in model.commodity_combo"
          :label="`配件${index + 1}：`"
          :key="index"
          class="mb-10"
        >
          <div style="display: flex">
            <!-- <el-input
              v-model="item.name"
              placeholder="选择配件"
              style="width: 177px; min-width: 177px"
            ></el-input> -->
            <CommoditySelect
              :val="item.id"
              @change="item.id = $event"
              :departmentLimit="false"
              :status="0"
            ></CommoditySelect>
            <el-input-number
              v-model="item.number"
              :min="1"
              :max="1000"
              label="配件数量"
              class="ml-10"
              style="width: 140px; min-width: 140px"
            ></el-input-number>
            <el-button
              class="ml-10"
              @click="model.commodity_combo.splice(index, 1)"
              >删除</el-button
            >
          </div>
        </div>
        <el-button
          size="mini"
          type="primary"
          @click="
            model.commodity_combo.push({
              id: '',
              part_number: '',
              number: 1,
            })
          "
          >添加配件</el-button
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import {
  createMaintainanceRule,
  updateMaintainanceRule,
} from '@/service/getData'
import DeviceApplicationSelect from '@/components/select/device_application_select'
import DeviceCraftSelect from '@/components/select/device_craft_select'
import CommoditySelect from '@/components/select/commodity_select'
import ItemCategorySelect from '@/components/select/item_category_select'

export default {
  components: {
    DeviceApplicationSelect,
    DeviceCraftSelect,
    CommoditySelect,
    ItemCategorySelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '请填写规则名称', trigger: 'change' },
        ],
        // item_category_id: [
        //   { required: true, message: '请选择设备分类', trigger: 'change' },
        // ],
        // equipment_number: [
        //   { required: true, message: '请填写设备号', trigger: 'change' },
        // ],
        // application: [
        //   { required: true, message: '请选择应用', trigger: 'change' },
        // ],
        // craft: [{ required: true, message: '请选择工艺', trigger: 'change' }],
        period: [
          { required: true, message: '请填写保养周期', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      if (!this.model.item_category_id && !this.model.equipment_number) {
        this.$alert('设备分类和设备号不能同时为空')
        return
      }
      if (this.model.application.length > 0 && !this.model.equipment_number) {
        this.$alert('应用不为空时，设备号不能为空')
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.model.commodity_combo = this.model.commodity_combo.filter(
            (item) => item.id > 0
          )
          if (this.model.id > 0) {
            let res = await updateMaintainanceRule(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createMaintainanceRule(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('created', res.data)
            }
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>